import { ArticlePurchaseLinkFactory } from "./ArticlePurchaseLinkFactory";
import { ArticlePurchaseLinkProps } from "./types";

export default function ArticlePurchaseLink({
  ...props
}: ArticlePurchaseLinkProps): React.ReactElement {
  return (
    <section
      className="track-impression mx-auto my-4 w-full"
      data-testid="article-purchase-link-component"
      data-section-name="end-of-article"
    >
      <ArticlePurchaseLinkFactory {...props} />
    </section>
  );
}
